<div class="page-wrapper" *ngIf="!selectedFcu">
    <div class="overview-container">
        <div class="overview-wrapper">
            <div *ngFor="let fcu of fcuStatusObject | keyvalue; index as i">
                <app-fcu-list-status-indicator
                    [isReceivingData]="isReceivingData"
                    [fcuSrc]="fcu.key"
                    [fcu]="fcu.value"
                    (onSelectFcu)="handleSelectedFcu(fcu)"
                ></app-fcu-list-status-indicator>
            </div>
        </div>
    </div>
</div>

<div class="selected-comm-wrapper" *ngIf="selectedFcu">
    <div></div>
    <app-fcu-status-indicator
        [isReceivingData]="isReceivingData"
        [fcuSrc]="selectedFcuSrc"
        [selectedFcu]="selectedFcu"
        [selectedFu]="selectedFu"
        (onGoBack)="handleSelectedFcu(null)"
    ></app-fcu-status-indicator>
</div>
